import { render, staticRenderFns } from "./correction-add-or-update.vue?vue&type=template&id=043dd52e"
import script from "./correction-add-or-update.vue?vue&type=script&lang=js"
export * from "./correction-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports